export class Faq {
	constructor() {
		this.searchInput = document.querySelector('.faq-search__input');
		this.searchBtn = document.querySelector('.faq-search__btn');
		this.tabsBlock = document.querySelector('.levit_tabs_block');
		this.faqRoot = document.querySelector('.faq');

		// Only run on FAQ pages — do not touch staff/other tab UIs.
		if (!this.searchInput && !this.faqRoot) {
			return;
		}

		this.init();
	}

	init() {
		this.observeVisibility();
		this.bindSearch();
		this.bindTabs();
		this.bindShare();
		this.waitForTabs(() => this.restoreFromUrl());
	}

	tabItems() {
		const root = this.tabsBlock || this.faqRoot || document;
		return [...root.querySelectorAll('.tabs_list_item')];
	}

	contentContainers() {
		const root = this.tabsBlock || this.faqRoot || document;
		return [...root.querySelectorAll('.tabs_content_container > .wp-block-group')];
	}

	listingItems() {
		const root = this.tabsBlock || this.faqRoot || document;
		return [...root.querySelectorAll('.tabs_content_container .jet-listing-grid__item')];
	}

	waitForTabs(callback) {
		const check = () => {
			const containers = this.contentContainers();
			const activeContent = containers.find(
				(el) =>
					el.classList.contains('active') ||
					(el.style.display !== 'none' && getComputedStyle(el).display !== 'none')
			);
			const items = this.listingItems();

			if (activeContent && items.length > 0) {
				callback();
			} else {
				requestAnimationFrame(check);
			}
		};
		requestAnimationFrame(check);
	}

	observeVisibility() {
		if (!this.faqRoot) return;

		const toggle = () => {
			const isHidden = this.faqRoot.classList.contains('hide');
			if (this.tabsBlock) this.tabsBlock.style.display = isHidden ? 'none' : '';
			const searchWrap = document.querySelector('.faq-search');
			if (searchWrap) searchWrap.style.display = isHidden ? 'none' : '';
		};

		toggle();
		new MutationObserver(toggle).observe(this.faqRoot, { attributes: true, attributeFilter: ['class'] });
	}

	restoreFromUrl() {
		const params = new URLSearchParams(location.search);
		const search = params.get('faq_search') || '';
		const tab = parseInt(params.get('faq_tab')) || 0;

		this.activateTab(tab);

		if (search && this.searchInput) {
			this.searchInput.value = search;
			setTimeout(() => this.applyFilter(search), 50);
		}
	}

	activateTab(index) {
		const target = this.tabItems()[index];
		if (target && !target.classList.contains('active')) target.click();
	}

	bindSearch() {
		if (!this.searchBtn || !this.searchInput) return;
		this.searchBtn.addEventListener('click', () => this.triggerSearch());
		this.searchInput.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') this.triggerSearch();
		});
	}

	triggerSearch() {
		const val = this.searchInput.value;
		this.applyFilter(val);
		this.setParams(val, this.getActiveTabIndex());
	}

	bindTabs() {
		this.tabItems().forEach((tab) => {
			tab.addEventListener('click', () => {
				const index = this.tabItems().indexOf(tab);
				const currentSearch = this.searchInput?.value || '';
				this.setParams(currentSearch, index);
				if (currentSearch) this.applyFilter(currentSearch);
			});
		});
	}

	applyFilter(query) {
		const q = query.toLowerCase().trim();
		const containers = this.contentContainers();
		const items = this.listingItems();

		if (!q) {
			items.forEach((item) => (item.style.display = ''));
			containers.forEach((el, i) => {
				el.style.display = i === this.getActiveTabIndex() ? '' : 'none';
			});
			return;
		}

		containers.forEach((el) => (el.style.display = ''));
		items.forEach((item) => {
			const title = item.querySelector('.ac-header h4')?.textContent.toLowerCase() || '';
			const body = item.querySelector('.ac-panel')?.textContent.toLowerCase() || '';
			item.style.display = title.includes(q) || body.includes(q) ? '' : 'none';
		});
	}

	getActiveTabIndex() {
		return this.tabItems().findIndex((t) => t.classList.contains('active'));
	}

	setParams(search, tabIndex) {
		const url = new URL(location.href);
		search ? url.searchParams.set('faq_search', search) : url.searchParams.delete('faq_search');
		url.searchParams.set('faq_tab', tabIndex);
		history.replaceState(null, '', url.toString());
	}

	bindShare() {
		document.addEventListener('click', (e) => {
			const btn = e.target.closest('.faq-share__item');
			if (!btn) return;

			const item = btn.closest('.jet-listing-grid__item');
			if (!item) return;

			const title = item.querySelector('.ac-header h4')?.textContent.trim() || document.title;
			const text = item.querySelector('.ac-panel')?.textContent.trim().replace(/\s+/g, ' ') || '';
			const url = window.location.href;

			const shareUrl = this.buildShareUrl(btn.dataset.href, { title, text, url });
			if (shareUrl) window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=600');
		});
	}

	buildShareUrl(baseHref, { title, text, url }) {
		if (!baseHref) return null;

		if (baseHref.includes('linkedin.com')) {
			return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
		}

		if (baseHref.includes('x.com') || baseHref.includes('twitter.com')) {
			const tweetText = text ? `${title} — ${text}` : title;
			return `https://x.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(tweetText.slice(0, 250))}`;
		}

		if (baseHref.includes('facebook.com')) {
			return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`;
		}

		return baseHref;
	}
}
